import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { Button } from "./ui/button";

export class SectionErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error(`Errore nella sezione "${this.props.title || "pagina"}"`, error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="section-error" role="alert" className="rounded-lg border border-[#942F30]/30 bg-[#942F30]/5 p-5 my-4">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-[#942F30] shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-slate-800 text-sm">Impossibile visualizzare {this.props.title ? `la sezione "${this.props.title}"` : "questa pagina"}</p>
            <p className="text-xs text-slate-600 mt-1">Si è verificato un errore imprevisto. Il resto della scheda resta disponibile. Dettaglio tecnico: <span className="font-mono">{String(this.state.error?.message || this.state.error)}</span></p>
            <Button data-testid="section-error-retry" variant="outline" size="sm" className="mt-3 gap-1.5" onClick={() => this.setState({ error: null })}><RotateCcw className="h-3.5 w-3.5" /> Riprova</Button>
          </div>
        </div>
      </div>
    );
  }
}
